import axios from 'axios'

const state = {
    cart: [],
    wishlist: []
};

const getters = {
    cart: state => state.cart,
    wishlist: state => state.wishlist,
    itemsCount(state) {
        if (state.cart) {
            return state.cart.length;
        } else {
            return 0;
        }
    },
    subTotal: state => {
        let sum = 0;
        state.cart.forEach(row => {
            sum += parseFloat(row.total);
        });
        //adding delivery charge
        sum = sum + 30;
        return Math.ceil(sum).toFixed(2);
    }
};

const actions = {
    getCart({commit, state}) {
        axios.get('http://admin.dokaandar.com/api/cart/' + localStorage.getItem('session_id'))
            .then(r => r.data)
            .then(response => {
                state.cart = response.data;
            })
    },
    deleteFromCart({commit}, payload) {
        axios.delete('http://admin.dokaandar.com/api/cart/' + payload.id)
            .then(r => r.data)
            .then(response => {
                this.dispatch('getCart');
            })
    },
    addToCart({commit}, payload) {
        console.log(payload);
    //    this.dispatch('addItemToCart')
        // axios.post('http://admin.dokaandar.com/api/cart', payload).then((response) => {
        //     this.dispatch('getCart');
        // }).catch((e) => {
        //     console.log(e)
        // })
    },
    removeItemQty({commit}, payload) {
        axios.get('http://admin.dokaandar.com/api/removeItemQty/' + payload.id).then((response) => {
            this.dispatch('getCart');
        }).catch((e) => {
            console.log(e)
        })
    },
    addItemQty({commit}, payload) {
        axios.get('http://admin.dokaandar.com/api/addItemQty/' + payload.id).then((response) => {
            this.dispatch('getCart');
        }).catch((e) => {
            console.log(e)
        })
    },
    getWishlist({commit, state}) {
        axios.get('http://admin.dokaandar.com/api/wishlist', {headers: {Authorization: `Bearer ${localStorage.getItem('token')}`}})
            .then(r => r.data)
            .then(response => {
                console.log(response.data);
                state.wishlist = response.data;
            })
    },
    deleteFromWishlist({commit}, payload) {
        axios.delete('http://admin.dokaandar.com/api/wishlist/' + payload.id, {headers: {Authorization: `Bearer ${localStorage.getItem('token')}`}})
            .then(r => r.data)
            .then(response => {
                this.dispatch('getWishlist');
            })
    },
    addToWishlist({commit}, payload) {
        axios.post('http://admin.dokaandar.com/api/wishlist', payload, {headers: {Authorization: `Bearer ${localStorage.getItem('token')}`}}).then((response) => {
            this.dispatch('getWishlist');
        }).catch((e) => {
            console.log(e)
        })
    }
};

const mutations = {
        addItemToCart: (state, value) => {
            if (!_.some(state.cart, {itemId: 1})) {
                state.cart.push(value);
            }
            console.log(state);
        }
};

export default {
    state,
    getters,
    actions,
    mutations
}